(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("Contact", [
            'jquery',
            'request',
            'map',
            'main.js'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(
            require('jquery'),
            require('request'),
            require('map'),
            require('main.js')
        );
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(
            root.jquery,
            root.formRequest,
            root.map,
            root.main
        );
    }
}(typeof self !== 'undefined' ? self : this, function ($, formRequest, map, main) {
    
    // google map init
    map.init();

    $(function () {

        let buttonHtml = $('.form--contact').find('[name="contactSubmit"]').html();

        $('.form--contact').w5request({
            selector: '.form--contact',
            beforeSend: function () {
                this.find('[name="contactSubmit"]').attr('disabled', 'disabled').addClass('active').html(function () {
                    return $(this).data('loading-text')
                });
            },
            complete: function (response, request) {
                console.log(request);
                this.replaceWith(response.data.html);
            },
            success: function (response, request) {

                console.log(request);

                this.find('input, textarea').each(function () {
                    $(this).removeClass('has-error');

                    switch ( $(this).prop('type') ) {
                        case "checkbox":
                            $(this).removeAttr('checked');
                            $(this).trigger('click');
                            break;

                        case "hidden":
                            break;

                        default:
                            $(this).val(null);
                            break;
                    }
                });

                this.find('.form-message').remove();
                this.find('[name="contactSubmit"]').removeClass('active').removeAttr('disabled').html(buttonHtml);

                this.prepend("<div class='form-message has-success'><p>" + this.data('success-text') + "</p></div>");
            }
        });
    });


}));


//////////////////
// WEBPACK FOOTER
// ./js/pages/contact/index.js
// module id = 24
// module chunks = 2